import React from 'react';
import { BadgeCheckIcon } from 'lucide-react';
export function AuthorNote() {
  return <section className="w-full bg-[#F5F2EB] py-16 px-4" data-id="element-31" data-mp="37pyj5n4s5yuo">
      <div className="max-w-3xl mx-auto" data-id="element-32" data-mp="37rjidq21i5yv">
        <div className="flex flex-col md:flex-row gap-8 items-start" data-id="element-33" data-mp="2sthc383mj6dx">
          {/* Profile Photo */}
          <div className="flex-shrink-0 mx-auto md:mx-0" data-id="element-34" data-mp="2xriv5t11v5pe">
            <div className="w-24 h-24 rounded-full bg-[#1B3022] flex items-center justify-center text-white text-3xl font-serif font-bold shadow-lg" data-id="element-35" data-mp="2xu51xqg49h6k">
              SS
            </div>
          </div>

          {/* Note Text */}
          <div data-id="element-36" data-mp="3bs3bmijhspfq">
            <h3 className="font-serif text-2xl font-bold text-[#1B3022] mb-4" data-id="element-37" data-mp="3bslj6bbluq2y">
              Una nota personal para ti
            </h3>

            <div className="font-serif text-[#3a3a32] text-lg leading-relaxed space-y-4" data-id="element-38" data-mp="3gp3kf17q86aj">
              <p data-id="element-39" data-mp="89jvufi03c1t">
                Creé este protocolo después de años viviendo solo en Santiago y
                viendo cómo mi sueldo desaparecía en el supermercado sin
                explicación lógica.
              </p>
              <p data-id="element-40" data-mp="3ehbcpotd97gg">
                No soy chef ni nutricionista. Soy alguien que se cansó de pagar
                de más y decidió aplicar ingeniería a un problema que todos los
                solteros enfrentamos en silencio:{' '}
                <span className="font-semibold text-[#1B3022]" data-id="element-41" data-mp="3jhz3qahlhoao">
                  el sistema de retail no está diseñado para nosotros.
                </span>
              </p>
              <p data-id="element-42" data-mp="3saudnhi0c86s">
                Cada dato, cada tabla y cada recomendación de este protocolo
                viene de auditorías reales que hice personalmente en pasillos de
                supermercados chilenos. Nada es teórico. Todo está probado.
              </p>
              <p data-id="element-43" data-mp="64dx9766j0s2">
                Si estás leyendo esto, ya diste el primer paso. Ahora solo falta
                que actúes.
              </p>
            </div>

            {/* Signature */}
            <div className="mt-8 mb-6" data-id="element-44" data-mp="27wk14b0v6tvp">
              <p className="font-serif italic text-2xl text-[#1B3022]/70" style={{
              fontFamily: "'Playfair Display', Georgia, serif"
            }} data-id="element-45" data-mp="2xj4mhk0lotc5">
                — El equipo Solo-Survival
              </p>
            </div>

            {/* Credibility Badge */}
            <div className="inline-flex items-center gap-2 bg-[#1B3022]/10 border border-[#1B3022]/20 rounded-full px-5 py-2.5" data-id="element-46" data-mp="3bjxg82j2vke7">
              <BadgeCheckIcon className="w-5 h-5 text-[#1B3022]" data-id="element-47" data-mp="3ghqm0uggycdy" />
              <span className="text-sm font-medium text-[#1B3022]" data-id="element-48" data-mp="3kiiv9npccha8">
                Basado en auditorías reales de precios en Lider, Jumbo y Alvi
                (Chile 2025-2026)
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}